<template>
    <div>
        <div class="container" style="display: flex; align-items: flex-start; padding: 0 30px 30px">
            <div class="leftbox" style="width: 15%">
                <div class="titlea">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item> <i class="el-icon-setting"></i> 打印模板 </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <ul>
                    <li
                        v-for="(item, index) in selectList"
                        :key="index"
                        v-bind:class="{ bgSelect: item.id == current }"
                        @click="selectValue(item.id, index, item.name)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </div>
            <div style="width: 85%">
                <div class="handle-box" style="display: flex; align-items: center; justify-content: space-between">
                    <div></div>
                    <div>
                        <el-button type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd">添加</el-button>
                    </div>
                </div>
                <el-table
                    :data="tableDataList"
                    border
                    stripe
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                    @selection-change="handleSelectionChange"
                >
                    <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->

                    <el-table-column prop="model_code" label="模板编码" align="center"></el-table-column>
                    <el-table-column prop="model_name" label="模板名称" align="center"></el-table-column>
                    <el-table-column v-if="systemSet.isstores == 1" prop="store_no" label="所属门店编号" align="center"></el-table-column>
                    <el-table-column v-if="systemSet.isstores == 1" prop="store_name" label="所属门店名称" align="center"></el-table-column>
                    <el-table-column label="默认" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.is_default == 1 ? 'success' : 'danger'">{{
                                    scope.row.is_default == 1 ? '是' : '否'
                                }}</el-tag>
                            <el-switch
                                v-model="scope.row.is_default"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                                @change="tableDataStatus(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                                    scope.row.status == 1 ? '启用' : '停用'
                                }}</el-tag>
                            <el-switch
                                v-model="scope.row.status"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                                @change="tableDataStatus(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="systemSet.isstores == 1" prop="isstoregeneral" label="门店通用" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.isstoregeneral == 1 ? 'success' : 'danger'">{{
                                    scope.row.isstoregeneral == 1 ? '是' : '否'
                                }}</el-tag>
                            <el-switch
                                v-model="scope.row.isstoregeneral"
                                style="margin-left: 5px"
                                :active-value="1"
                                :inactive-value="0"
                                @change="tableDataStatus(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="center" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                            <el-button type="text" class="red" @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1"
                            >{{ $t('common.delete') }}</el-button
                            >
                            <el-button type="text" style="color: #ebb563" @click="handleCopy(scope.row)">复制</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageIndex"
                        :page-sizes="[5, 10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        @size-change="pageSizeChange"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加类别 -->

        <el-drawer :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addData_isshow" direction="rtl" size="50%">
            <div style="overflow: scroll; height: 1200px; padding-bottom: 350px">
                <el-form label-width="120px" style="margin-right: 20px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="模块">
                                {{ titleName }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-col :span="2">
                                <el-button type="primary" @click="EditPull" v-if="!isAdd">{{ $t('common.refresh') }}</el-button>
                            </el-col>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="模板编码">
                                <el-input v-model="tableData.model_code" @blur="interBlur" :disabled="!isAdd"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="模板名称">
                                <el-input type="text" v-model="tableData.model_name" maxlength="20"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12"
                            ><el-form-item label="字体大小">
                                <el-input type="text" v-model="tableData.name_size"></el-input>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="20">
                        <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                            <el-select
                                v-model="tableData.store_no"
                                clearable
                                filterable
                                default-first-option
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in store"
                                    :key="index"
                                    :label="item.store_name"
                                    :value="item.store_no"
                                >
                                    <span style="margin-left: 10px">{{ item.store_name }}</span>
                                    <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-col :span="12">
                            <el-form-item label="门店通用" v-if="systemSet.isstores == 1" >
                                <el-tag :type="tableData.isstoregeneral == 1 ? 'success' : 'danger'">{{
                                        tableData.isstoregeneral == 1 ? '是' : '否'
                                    }}</el-tag>
                                <el-switch v-model="tableData.isstoregeneral" style="margin-left: 5px" :active-value="1" :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12"
                        ><el-form-item label="默认">
                            <el-tag :type="tableData.is_default == 1 ? 'success' : 'danger'">{{
                                    tableData.is_default == 1 ? '是' : '否'
                                }}</el-tag>
                            <el-switch v-model="tableData.is_default" style="margin-left: 5px" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="状态">
                                <el-tag :type="tableData.status == 1 ? 'success' : 'danger'">{{
                                        tableData.status == 1 ? '启用' : '停用'
                                    }}</el-tag>
                                <el-switch v-model="tableData.status" style="margin-left: 5px" :active-value="1" :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="tableData.company">
                        <el-col :span="12">
                            <el-form-item label="企业名称">
                                <el-tag :type="tableData.company.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.company.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.company.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.company.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="tableData.title">
                        <el-col :span="12">
                            <el-form-item label="单据标题">
                                <el-tag :type="tableData.title.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.title.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.title.is_show" style="margin-left: 5px" :active-value="1" :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.title.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="tableData.header">
                        <el-col :span="12">
                            <el-form-item label="单据抬头">
                                <el-tag :type="tableData.header.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.header.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.header.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.header.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6" v-if="tableData.custno">
                            <el-form-item label="客户编号">
                                <el-tag :type="tableData.custno.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custno.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.custno.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.custname">
                            <el-form-item label="客户名称">
                                <el-tag :type="tableData.custname.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custname.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.custname.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.counterno">
                            <el-form-item label="柜台编号">
                                <el-tag :type="tableData.counterno.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.counterno.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.counterno.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.countername">
                            <el-form-item label="柜台名称">
                                <el-tag :type="tableData.countername.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.countername.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.countername.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6" v-if="tableData.billno">
                            <el-form-item label="单据编号">
                                <el-tag :type="tableData.billno.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.billno.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.billno.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.billdate">
                            <el-form-item label="单据日期">
                                <el-tag :type="tableData.billdate.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.billdate.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.billdate.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.billremark">
                            <el-form-item label="单据备注">
                                <el-tag :type="tableData.billremark.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.billremark.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.billremark.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tableData.printdate">
                            <el-form-item label="打印时间">
                                <el-tag :type="tableData.printdate.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.printdate.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.printdate.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="tableData.footer">
                        <el-col :span="12">
                            <el-form-item label="单据页脚">
                                <el-tag :type="tableData.footer.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.footer.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.footer.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.footer.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="tableData.is_tot">
                        <el-col :span="12">
                            <el-form-item label="金额合计">
                                <el-tag :type="tableData.is_tot.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.is_tot.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.is_tot.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.is_tot.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <!--期初存欠-->
                    <el-row :gutter="10" v-if="tableData.custaccounts_begin">
                        <el-col :span="4">
                            <el-form-item label="期初存欠">
                                <el-tag :type="tableData.custaccounts_begin.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_begin.is_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_begin.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="料账">
                                <el-tag :type="tableData.custaccounts_begin.metal_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_begin.metal_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_begin.metal_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="钱账">
                                <el-tag :type="tableData.custaccounts_begin.money_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_begin.money_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_begin.money_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="排序">
                                <el-input-number
                                    v-model="tableData.custaccounts_begin.seq"
                                    :min="1"
                                    :max="3"
                                    size="small"
                                    style="width: 100%"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="字体大小">
                                <el-input type="text" v-model="tableData.custaccounts_begin.font_size"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--本期存欠-->
                    <el-row :gutter="10" v-if="tableData.custaccounts_now">
                        <el-col :span="4">
                            <el-form-item label="本期存欠">
                                <el-tag :type="tableData.custaccounts_now.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_now.is_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_now.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="料账">
                                <el-tag :type="tableData.custaccounts_now.metal_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_now.metal_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_now.metal_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="钱账">
                                <el-tag :type="tableData.custaccounts_now.money_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_now.money_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_now.money_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="排序">
                                <el-input-number
                                    v-model="tableData.custaccounts_now.seq"
                                    :min="1"
                                    :max="3"
                                    size="small"
                                    style="width: 100%"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="字体大小">
                                <el-input type="text" v-model="tableData.custaccounts_now.font_size"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--期末存欠-->
                    <el-row :gutter="10" v-if="tableData.custaccounts_end">
                        <el-col :span="4">
                            <el-form-item label="期末存欠">
                                <el-tag :type="tableData.custaccounts_end.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_end.is_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_end.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="料账">
                                <el-tag :type="tableData.custaccounts_end.metal_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_end.metal_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_end.metal_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="钱账">
                                <el-tag :type="tableData.custaccounts_end.money_show == 1 ? 'success' : 'danger'">{{
                                        tableData.custaccounts_end.money_show == 1 ? '显示' : '隐藏'
                                    }}
                                </el-tag>
                                <el-switch
                                    v-model="tableData.custaccounts_end.money_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="排序">
                                <el-input-number
                                    v-model="tableData.custaccounts_end.seq"
                                    :min="1"
                                    :max="3"
                                    size="small"
                                    style="width: 100%"
                                ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="字体大小">
                                <el-input type="text" v-model="tableData.custaccounts_end.font_size"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--备注-->
                    <el-row :gutter="20" v-if="tableData.remark">
                        <el-col :span="12">
                            <el-form-item label="备注">
                                <el-tag :type="tableData.remark.is_show == 1 ? 'success' : 'danger'">{{
                                        tableData.remark.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                <el-switch
                                    v-model="tableData.remark.is_show"
                                    style="margin-left: 5px"
                                    :active-value="1"
                                    :inactive-value="0"
                                >
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"
                        ><el-form-item label="字体大小">
                            <el-input type="text" v-model="tableData.remark.font_size"></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="" v-if="tableData.remark">
                        <el-input type="textarea" v-model="tableData.remark.content" placeholder="请输入备注内容"></el-input>
                    </el-form-item>
                    <div v-if="tableData.fields1 != null">
                        <el-form-item>
                            <span slot="label" @click="shouinbound = !shouinbound"
                            ><span style="color: #f56c6c; font-size: 14px">
                                    <i class="el-icon-caret-right" v-if="!shouinbound" style="color: #409eff"></i>
                                    <i class="el-icon-caret-bottom" v-else style="color: #409eff"></i></span
                            >{{ tableData.table_name1 }}</span
                            >

                            <el-tag :type="tableData.is_fields1 == 1 ? 'success' : 'danger'">{{
                                    tableData.is_fields1 == 1 ? '显示' : '隐藏'
                                }}</el-tag>
                            <el-switch v-model="tableData.is_fields1" :active-value="1" :inactive-value="0"> </el-switch>
                            <template>
                                <el-tag :type="tableData.is_fields1_frame == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.is_fields1_frame == 1 ? '边框显示' : '边框隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.is_fields1_frame" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table_name1_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table_name1_show == 1 ? '名称显示' : '名称隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table_name1_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table1_groupByPrc == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table1_groupByPrc == 1 ? '按价格分组' : '按名称分组'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table1_groupByPrc" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table1_total_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table1_total_show == 1 ? '合计显示' : '合计隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table1_total_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag type="success" style="margin-left: 20px">下边距</el-tag>
                                <el-input v-model="tableData.table1_bottommargin" style="width: 80px"></el-input>
                            </template>
                        </el-form-item>
                    </div>
                    <div v-show="shouinbound">
                        <el-form-item v-if="tableData.table_name1">
                            <template>
                                <el-table :data="tableData.fields1" style="width: 100%">
                                    <el-table-column type="index" width="50" align="center"> </el-table-column>
                                    <el-table-column prop="name" label="字段名称" align="center"> </el-table-column>
                                    <el-table-column prop="ename" label="别名" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.ename"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="显示" align="center">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">{{
                                                    scope.row.is_show == 1 ? '显示' : '隐藏'
                                                }}</el-tag>
                                            <el-switch
                                                v-model="scope.row.is_show"
                                                style="margin-left: 5px"
                                                :active-value="1"
                                                :inactive-value="0"
                                            >
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="size" label="宽度" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="align" label="对齐方式" align="center">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.align" filterable placeholder="请选择">
                                                <el-option
                                                    v-for="item in optionsList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="font_size" label="字体大小" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.font_size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields1', -1)"
                                            >上移</el-button
                                            >
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields1', 1)"
                                            >下移</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </div>

                    <div v-if="tableData.fields2 != null">
                        <el-form-item>
                            <span slot="label" @click="shouinbound2 = !shouinbound2"
                            ><span style="color: #f56c6c; font-size: 14px">
                                    <i class="el-icon-caret-right" v-if="!shouinbound2" style="color: #409eff"></i>
                                    <i class="el-icon-caret-bottom" v-else style="color: #409eff"></i></span
                            >{{ tableData.table_name2 }}</span
                            >

                            <el-tag :type="tableData.is_fields2 == 1 ? 'success' : 'danger'">{{
                                    tableData.is_fields2 == 1 ? '显示' : '隐藏'
                                }}</el-tag>
                            <el-switch v-model="tableData.is_fields2" :active-value="1" :inactive-value="0"> </el-switch>
                            <template>
                                <el-tag :type="tableData.is_fields2_frame == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.is_fields2_frame == 1 ? '边框显示' : '边框隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.is_fields2_frame" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table_name2_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table_name2_show == 1 ? '名称显示' : '名称隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table_name2_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table2_groupByPrc == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table2_groupByPrc == 1 ? '按价格分组' : '按名称分组'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table2_groupByPrc" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table2_total_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table2_total_show == 1 ? '合计显示' : '合计隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table2_total_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag type="success" style="margin-left: 20px">下边距</el-tag>
                                <el-input v-model="tableData.table2_bottommargin" style="width: 80px"></el-input>
                            </template>
                        </el-form-item>
                    </div>

                    <div v-show="shouinbound2">
                        <el-form-item v-if="tableData.table_name2">
                            <template>
                                <el-table :data="tableData.fields2" style="width: 100%">
                                    <el-table-column type="index" width="50" align="center"> </el-table-column>
                                    <el-table-column prop="name" label="字段名称" align="center"> </el-table-column>
                                    <el-table-column prop="ename" label="别名" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.ename"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="显示" align="center">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">{{
                                                    scope.row.is_show == 1 ? '显示' : '隐藏'
                                                }}</el-tag>
                                            <el-switch
                                                v-model="scope.row.is_show"
                                                style="margin-left: 5px"
                                                :active-value="1"
                                                :inactive-value="0"
                                            >
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="size" label="宽度" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="align" label="对齐方式" align="center">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.align" filterable placeholder="请选择">
                                                <el-option
                                                    v-for="item in optionsList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="font_size" label="字体大小" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.font_size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields2', -1)"
                                            >上移</el-button
                                            >
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields2', 1)"
                                            >下移</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </div>

                    <div v-if="tableData.fields3 != null">
                        <el-form-item>
                            <span slot="label" @click="shouinbound3 = !shouinbound3"
                            ><span style="color: #f56c6c; font-size: 14px">
                                    <i class="el-icon-caret-right" v-if="!shouinbound3" style="color: #409eff"></i>
                                    <i class="el-icon-caret-bottom" v-else style="color: #409eff"></i></span
                            >{{ tableData.table_name3 }}</span
                            >

                            <el-tag :type="tableData.is_fields3 == 1 ? 'success' : 'danger'">{{
                                    tableData.is_fields3 == 1 ? '显示' : '隐藏'
                                }}</el-tag>
                            <el-switch v-model="tableData.is_fields3" :active-value="1" :inactive-value="0"> </el-switch>

                            <template>
                                <el-tag :type="tableData.is_fields3_frame == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.is_fields3_frame == 1 ? '边框显示' : '边框隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.is_fields3_frame" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table_name3_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table_name3_show == 1 ? '名称显示' : '名称隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table_name3_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table3_groupByPrc == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table3_groupByPrc == 1 ? '按价格分组' : '按名称分组'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table3_groupByPrc" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table3_total_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table3_total_show == 1 ? '合计显示' : '合计隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table3_total_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag type="success" style="margin-left: 20px">下边距</el-tag>
                                <el-input v-model="tableData.table3_bottommargin" style="width: 80px"></el-input>
                            </template>
                        </el-form-item>
                    </div>
                    <div v-show="shouinbound3">
                        <el-form-item v-if="tableData.table_name3">
                            <template>
                                <el-table :data="tableData.fields3" style="width: 100%">
                                    <el-table-column type="index" width="50" align="center"> </el-table-column>
                                    <el-table-column prop="name" label="字段名称" align="center"> </el-table-column>
                                    <el-table-column prop="ename" label="别名" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.ename"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="显示" align="center">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">{{
                                                    scope.row.is_show == 1 ? '显示' : '隐藏'
                                                }}</el-tag>
                                            <el-switch
                                                v-model="scope.row.is_show"
                                                style="margin-left: 5px"
                                                :active-value="1"
                                                :inactive-value="0"
                                            >
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="size" label="宽度" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="align" label="对齐方式" align="center">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.align" filterable placeholder="请选择">
                                                <el-option
                                                    v-for="item in optionsList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="font_size" label="字体大小" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.font_size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields3', -1)"
                                            >上移</el-button
                                            >
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields3', 1)"
                                            >下移</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </div>

                    <div v-if="tableData.fields4 != null">
                        <el-form-item>
                            <span slot="label" @click="shouinbound4 = !shouinbound4"
                            ><span style="color: #f56c6c; font-size: 14px">
                                    <i class="el-icon-caret-right" v-if="!shouinbound4" style="color: #409eff"></i>
                                    <i class="el-icon-caret-bottom" v-else style="color: #409eff"></i></span
                            >{{ tableData.table_name4 }}</span
                            >

                            <el-tag :type="tableData.is_fields4 == 1 ? 'success' : 'danger'">{{
                                    tableData.is_fields4 == 1 ? '显示' : '隐藏'
                                }}</el-tag>
                            <el-switch v-model="tableData.is_fields4" :active-value="1" :inactive-value="0"> </el-switch>

                            <template>
                                <el-tag :type="tableData.is_fields4_frame == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.is_fields4_frame == 1 ? '边框显示' : '边框隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.is_fields4_frame" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table_name4_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table_name4_show == 1 ? '名称显示' : '名称隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table_name4_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table4_groupByPrc == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table4_groupByPrc == 1 ? '按价格分组' : '按名称分组'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table4_groupByPrc" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag :type="tableData.table4_total_show == 1 ? 'success' : 'danger'" style="margin-left: 20px">{{
                                        tableData.table4_total_show == 1 ? '合计显示' : '合计隐藏'
                                    }}</el-tag>
                                <el-switch v-model="tableData.table4_total_show" :active-value="1" :inactive-value="0"> </el-switch>

                                <el-tag type="success" style="margin-left: 20px">下边距</el-tag>
                                <el-input v-model="tableData.table4_bottommargin" style="width: 80px"></el-input>
                            </template>
                        </el-form-item>
                    </div>
                    <div v-show="shouinbound4">
                        <el-form-item v-if="tableData.table_name4">
                            <template>
                                <el-table :data="tableData.fields4" style="width: 100%">
                                    <el-table-column type="index" width="50" align="center"> </el-table-column>
                                    <el-table-column prop="name" label="字段名称" align="center"> </el-table-column>
                                    <el-table-column prop="ename" label="别名" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.ename"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="显示" align="center">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">{{
                                                    scope.row.is_show == 1 ? '显示' : '隐藏'
                                                }}</el-tag>
                                            <el-switch
                                                v-model="scope.row.is_show"
                                                style="margin-left: 5px"
                                                :active-value="1"
                                                :inactive-value="0"
                                            >
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="size" label="宽度" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="align" label="对齐方式" align="center">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.align" filterable placeholder="请选择">
                                                <el-option
                                                    v-for="item in optionsList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="font_size" label="字体大小" align="center">
                                        <template slot-scope="scope">
                                            <el-input width="100px" v-model="scope.row.font_size"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields4', -1)"
                                            >上移</el-button
                                            >
                                            <el-button type="text" @click="handleMove(scope.$index, scope.row, 'fields4', 1)"
                                            >下移</el-button
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </div>
                </el-form>
                <span class="demo-drawer__footer" style="margin-left: 80%">
                    <el-button @click="addData_isshow = false">取 消</el-button>
                    <el-button type="primary" @click="saveAdd">确 定</el-button>
                </span>
            </div>
        </el-drawer>

        <el-dialog title="复制打印模板" :visible.sync="dialogVisible_copy" width="30%" :before-close="handleClose">
            <el-form label-width="80px" :model="formLabelAlign">
                <el-form-item label="模块名称">
                    {{ titleName }}
                </el-form-item>
                <el-form-item label="模板编码">
                    <el-input v-model="formLabelAlign.model_code"></el-input>
                </el-form-item>
                <el-form-item label="模板名称">
                    <el-input v-model="formLabelAlign.model_name"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleCopyAdd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '@/api/index';
import {
    printout_list,
    printout_pull,
    printout_dtl_list,
    update_printout_dtl,
    getPrinOut_dtl,
    add_printout_dtl,
    apiCurrentPermisson,
    delete_printout_dtl,
    copy_printout_dtl
} from '@/request/api';
export default {
    name: 'PrintOutSet',
    data() {
        return {
            copy_id: '',
            formLabelAlign: {},
            dialogVisible_copy: false,
            shouinbound: false,
            shouinbound2: false,
            shouinbound3: false,
            shouinbound4: false,
            store: [],
            remark: [],
            company: [],
            is_cunqian: [],
            is_tot: [],
            dialogVisible: false,
            optionsList: [
                {
                    value: 'left',
                    label: '居左'
                },
                {
                    value: 'center',
                    label: '居中'
                },
                {
                    value: 'right',
                    label: '居右'
                }
            ],
            name: '',
            pid: '12',
            titleName: '',
            selectList: [],
            delList: [],
            isAdd: true,
            addData_isshow: false,
            pageIndex: 1,
            pageSize: 10,
            editId: '',
            tableData: { fields: { is_default: '0' } },
            tableDataList: [],
            perData: '',
            pageTotal: 0,
            current: 1,
            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    // watch: {
    //     pid: function(val, oldval) {
    //
    //         this.getData();
    //     }
    // },
    created() {
        this.getListData();
        this.getData();
        this.getPull();
        this.getPermission();
        this.current = 0;
    },
    activated() {
        this.getPull();
        // this.getListData();
        // this.getData();
        this.getPermission();
        // this.current = 0;
    },
    methods: {
        // 修改排序的方法，`field` 参数指定操作哪个字段数组，`direction` 参数指定上移(-1)或下移(1)
        handleMove(index, row, field, direction) {
            const arr = this.tableData[field]; // 根据字段选择数组
            const targetIndex = index + direction; // 计算目标索引
            // 检查索引是否越界
            if (targetIndex < 0 || targetIndex >= arr.length) {
                return;
            }
            // 调用换位函数
            this.handleChangeOrder(arr, index, targetIndex);
        },

        // 通用的交换顺序方法
        handleChangeOrder(arr, indexAdd, indexDel) {
            arr[indexAdd] = arr.splice(indexDel, 1, arr[indexAdd])[0];
            return arr;
        },
        // 调整顺序，arr 数组，indexAdd 添加元素的位置，indexDel 删除元素的位置（indexAdd与indexDel交换位置）
        handleChangeOrder(arr, indexAdd, indexDel) {
            arr[indexAdd] = arr.splice(indexDel, 1, arr[indexAdd])[0];
            return arr;
        },

        handleClose() {
            this.dialogVisible_copy = false;
            this.formLabelAlign = {};
        },
        interBlur() {
            var pattern1 = /^[^\s]*$/; // 不包含空格的字符串
            var pattern2 = /^[^\u4e00-\u9fa5]+$/; // 匹配汉字的正则表达式
            if (this.tableData.model_code == '') {
            } else if (!pattern2.test(this.tableData.model_code) || !pattern1.test(this.tableData.model_code)) {
                this.tableData.model_code = '';
                this.$message.error('模板编码不能包含中文字符或者空格');
                return;
            }
        },
        // 获取下拉框信息----------------------------------------------------------------------------------------------------
        getListData() {
            printout_list({}).then((res) => {
                if (res.code == 2000) {
                    this.selectList = res.data;
                    if (localStorage.getItem('titleName')) {
                        this.titleName = localStorage.getItem('titleName');
                        // this.current = localStorage.getItem('pid');
                    } else {
                        this.titleName = res.data[0].name;
                    }
                    localStorage.setItem('pid', res.data.id);
                } else {
                    // this.$message.error(res.msg);
                }
            });
        },
        // 获取列表信息----------------------------------------------------------------------------------------------------
        getPull() {
            printout_pull({
                pid: this.pid || localStorage.getItem('pid'),
                page: this.pageIndex,
                page_size: this.pageSize
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.fields;
                    this.company = this.tableData.company;
                    this.is_cunqian = this.tableData.is_cunqian;
                    this.is_tot = this.tableData.is_tot;
                    this.remark = this.tableData.remark;
                    this.store = res.data.store;
                    this.$nextTick(() => {
                        if (this.store) {
                            const defaultStore = this.store.find((store) => store.isdefault == 1);
                            this.$set(this.tableData, 'store_no', defaultStore ? defaultStore.store_no : '');
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取列表信息----------------------------------------------------------------------------------------------------
        getData() {
            this.$load.show();
            printout_dtl_list({
                pid: this.pid || localStorage.getItem('pid'),
                page: this.pageIndex,
                page_size: this.pageSize
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableDataList = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //下拉选择部门----------------------------------------------------------------------------------------------------
        selectValue(number, inNO, name) {
            //
            this.pageIndex = 1;
            localStorage.setItem('pid', number);
            this.titleName = name;
            localStorage.setItem('titleName', this.titleName);
            this.pid = number;
            this.getPull();
            this.getData();
            this.current = number;
        },
        // 触发搜索按钮----------------------------------------------------------------------------------------------------
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '131'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData_isshow = true;
            this.isAdd = true;
            this.getPull();
            this.pid = this.pid || localStorage.getItem('pid');
        },
        saveAdd() {
            this.$load.show();
            let datanew = this.tableData;
            datanew.pid = this.pid || localStorage.getItem('pid');
            datanew.login_staff = localStorage.getItem('ms_username');
            if (!this.tableData.model_code) {
                this.$message.error('模块编码不能为空');
                this.$load.close();
                return;
            }
            let arr_come = this.tableData.fields1;
            if (arr_come.tot_come_size) {
                arr_come.forEach((item, index) => {
                    tot_come_size = parseInt(item.size) + parseInt(tot_come_size);
                });
                if (tot_come_size > 1000) {
                    this.$message.error(this.tableData.table_name + '宽度总计不能大于1000');
                    this.$load.close();
                    return;
                }
            }

            let arr_acc = this.tableData.fields2;
            if (this.tableData.fields2) {
                if (arr_acc.tot_acc_size) {
                    let tot_acc_size = 0;
                    arr_acc.forEach((item, index) => {
                        tot_acc_size = parseInt(item.size) + parseInt(tot_acc_size);
                    });
                    if (tot_acc_size > 1000) {
                        this.$message.error('账款明细宽度总计不能大于1000');
                        this.$load.close();
                        return;
                    }
                }
            }
            if (datanew.fields1 && Array.isArray(datanew.fields1)) {
                datanew.fields1.forEach((item, index) => {
                    item.seq = index + 1; // 假设seq按照表格中的顺序从1开始
                });
            }

            if (datanew.fields2 && Array.isArray(datanew.fields2)) {
                datanew.fields2.forEach((item, index) => {
                    item.seq = index + 1; // 假设seq按照表格中的顺序从1开始
                });
            }
            if (datanew.fields3 && Array.isArray(datanew.fields3)) {
                datanew.fields3.forEach((item, index) => {
                    item.seq = index + 1; // 假设seq按照表格中的顺序从1开始
                });
            }
            if (datanew.fields4 && Array.isArray(datanew.fields4)) {
                datanew.fields4.forEach((item, index) => {
                    item.seq = index + 1; // 假设seq按照表格中的顺序从1开始
                });
            }
            if (this.isAdd) {
                add_printout_dtl(datanew).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '添加成功', type: 'success' });
                        this.addData_isshow = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                    this.$load.close();
                });
            } else {
                update_printout_dtl(datanew).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '修改成功', type: 'success' });
                        this.addData_isshow = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                    this.$load.close();
                });
            }
        },
        EditPull() {
            printout_pull({
                pid: this.pid || localStorage.getItem('pid'),
                page: this.pageIndex,
                page_size: this.pageSize
            }).then((res) => {
                console.log(res, 'res');
                if (res.code == 2000) {
                    this.$message.success('已刷新,请点确定');
                    this.tableData = res.data.fields;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(scope) {
            this.addData_isshow = true;
            this.isAdd = false;
            this.pid = this.pid || localStorage.getItem('pid');
            this.editId = scope.row.id;
            getPrinOut_dtl({ id: this.editId }).then((res) => {
                this.tableData = res.data;
            });
        },

        tableDataStatus(row) {
            row.login_staff = localStorage.getItem('ms_username');
            update_printout_dtl(row).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.dialogVisible = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleCopy(row) {
            this.formLabelAlign = {};
            this.dialogVisible_copy = true;
            this.copy_id = row.id;
        },
        handleCopyAdd() {
            copy_printout_dtl({
                id: this.copy_id,
                model_name: this.formLabelAlign.model_name,
                model_code: this.formLabelAlign.model_code,
                login_staff: localStorage.getItem('ms_username')
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: '复制成功', type: 'success' });
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
                this.dialogVisible_copy = false;
            });
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    delete_printout_dtl({
                        id: row.id,
                        login_staff: localStorage.getItem('ms_username')
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function (item, index, array) {
                arr.push(item.kind_no);
            });
            this.delList = arr;
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    /* margin-bottom: 20px; */
    height: 50px;
    line-height: 50px;
    text-align: right;
}

.handle-select {
    width: 250px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.titlea .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    height: 50px;
    line-height: 50px;
    color: #000;
    font-weight: bold;
    font-size: 16px;
}
.leftbox ul {
    background: #ecf5ff;
    height: 700px;
    overflow-y: scroll;
}
.leftbox ul li {
    list-style: none;
    padding: 10px;
    font-size: 14px;
}
.bgSelect {
    background: #409eff;
    color: #fff;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
